module.exports = __webpack_public_path__ + "media/images/captive_portal/BL-reports-497002aa373f9a4d5285f17f3f396e42.svg";